<div class="accordion py-4">
  <ng-content></ng-content>
</div>
